export const ROLES = {
  ADMIN: 'administrador',
  MERCHANT: 'comerciante',
  MERCHANT_SERVICES: 'comerciante_servicos',
  MERCHANT_STAFF: 'usuario_comerciante',
} as const;

export type AppRole = (typeof ROLES)[keyof typeof ROLES];

/** Prefixos de rota permitidos por perfil (alinhado ao menus.seed). */
export const ROLE_ROUTE_PREFIXES: Record<string, string[]> = {
  [ROLES.ADMIN]: [
    '/dashboard',
    '/lojas',
    '/produtos',
    '/profissionais',
    '/cidades',
    '/banners',
    '/moderacao',
    '/usuarios',
    '/auditoria',
    '/boletos',
    '/relatorios',
    '/configuracoes',
  ],
  [ROLES.MERCHANT]: [
    '/dashboard',
    '/produtos',
    '/minha-loja',
    '/planos',
    '/boletos',
    '/relatorios',
  ],
  [ROLES.MERCHANT_SERVICES]: [
    '/dashboard',
    '/servicos',
    '/meu-perfil',
    '/planos',
    '/boletos',
    '/relatorios',
  ],
  [ROLES.MERCHANT_STAFF]: ['/dashboard', '/produtos'],
};

export function canAccessRoute(role: string | undefined, pathname: string): boolean {
  if (!role) return false;
  const prefixes = ROLE_ROUTE_PREFIXES[role];
  if (!prefixes) return false;
  return prefixes.some(
    (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`),
  );
}
